import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryFormat extends TitleBase {
	private countryValue: string;
	private formatValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.formatValue = this.getFilterValue(ParameterType.ATTENDANCE);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.ATTENDANCE)
		);
	}

	protected getPageTitle(): string {
		return `${this.formatValue} ${this.titlePortalType} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(
			`${this.formatValue.toLowerCase()} ${this.titlePortalType}`,
			` in ${this.countryValue}`
		);
	}
}
